import store from "../../../store";
import modif_groups from "./groups/modif_groups.vue";
import modificators from "./items/modificators.vue";

window.CATALOG_ATR =  new Vue({
    store,
    el: 'div#modif_block',

    name : "MODIF_BLOCK",

    created () {

    },
    components : {
        modif_groups,
        modificators
    }
});
